module.exports = "/img/5.30e1a3.webp";